// extracted by mini-css-extract-plugin
export default {"body":"body_body__RdL9M","mobile":"body_mobile__9utBy"};